export default {
    hasSaved: (state) => {
        return state.saved.length > 0
    }
}
